function padLeftZero(str: string): string {
    return ('00' + str).substr(str.length)
}

// 指定公司对应的时区转时间戳函数
function getLocalCompanyTimeStamp(timeZone: number, time: Date | string | number): number {
    // 参数i为时区值数字，比如北京为东八区则输进8
    let localTime: Date = new Date(time)
    // 得到当前时区的时间对应的时间戳
    let localTimeStamp: number = localTime.getTime()
    // 相比较零时区，相差多少小时。正数为向东，负数为向西(localTime.getTimezoneOffset() 获取当前时区的timeZone)
    let localZone: number = 0 - localTime.getTimezoneOffset() / 60
    // 比较当前时区和指定公司的时区相差的小时数
    let diffZone: number = localZone - timeZone
    // 在当地时间戳的基础上加减相差小时数的毫秒
    return localTimeStamp + 3600000 * diffZone
}

// 指定的公司对应的时区下的时间
export function getLocalCompanyTime(timeZone: number, time: Date | string | number): number {
    let localTime: Date = new Date(time)
    let localTimeStamp: number = localTime.getTime()
    let localZone: number = 0 - localTime.getTimezoneOffset() / 60
    let diffZone: number = localZone - timeZone
    return localTimeStamp - 3600000 * diffZone
}

export function formatDate(date: Date, fmt: string): string {
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
    }
    let o: Object = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
    }
    Object.keys(o).forEach(k => {
        if (new RegExp(`(${k})`).test(fmt)) {
            let str: string = o[k] + ''
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
        }
    })
    return fmt
}

// 起始时间转为时间戳格式
export function searchDateStart(time: Date | number | string, timeZone?: number | string): number | string {
    if (time) {
        let date: Date = new Date(time)
        date.setHours(0, 0, 0, 0)
        if (timeZone || timeZone === 'GMT') {  // GMT表示转成零时区的时间戳
            timeZone = timeZone === 'GMT' ? 0 : timeZone
            return getLocalCompanyTimeStamp(+timeZone, date)
        }
        return new Date(date).getTime()
    }
    return ''
}

// 结束时间转为时间戳格式
export function searchDateEnd(time: Date | number | string, timeZone?: number | string): number | string {
    if (time) {
        let date: Date = new Date(time)
        date.setHours(23, 59, 59, 999)
        if (timeZone || timeZone === 'GMT') {  // GMT表示转成零时区的时间戳
            timeZone = timeZone === 'GMT' ? 0 : timeZone
            return getLocalCompanyTimeStamp(+timeZone, date)
        }
        return new Date(date).getTime()
    }
    return ''
}

// 结束时间为12点的时间戳格式
export function searchDateMiddle(time: Date | number | string, timeZone?: number | string): number | string {
    if (time) {
        let date: Date = new Date(time)
        date.setHours(12, 0, 0, 0)
        if (timeZone || timeZone === 'GMT') {  // GMT表示转成零时区的时间戳
            timeZone = timeZone === 'GMT' ? 0 : timeZone
            return getLocalCompanyTimeStamp(+timeZone, date)
        }
        return new Date(date).getTime()
    }
    return ''
}

// 设置日期为time的月份第一天
export function setMonthStart(time: Date | number | string, timeZone?: number | string): number | string {
    if (time) {
        let date: Date = new Date(time)
        date.setDate(1)
        if (timeZone || timeZone === 'GMT') {  // GMT表示转成零时区的时间戳
            timeZone = timeZone === 'GMT' ? 0 : timeZone
            return getLocalCompanyTimeStamp(+timeZone, date)
        }
        return new Date(date).getTime()
    }
    return ''
}

// 设置日期为time的月份最后一天
export function setMonthEnd(time: Date | number | string, timeZone?: number | string): number | string {
    if (time) {
        let date: Date = new Date(time)
        date.setMonth(date.getMonth() + 1)
        date.setDate(0)
        if (timeZone || timeZone === 'GMT') {  // GMT表示转成零时区的时间戳
            timeZone = timeZone === 'GMT' ? 0 : timeZone
            return getLocalCompanyTimeStamp(+timeZone, date)
        }
        return new Date(date).getTime()
    }
    return ''
}


// 设置多少天以前或以后
export function getDaysAgo(time: Date | number | string, days: number): number | string {
    if (time) {
        let date: Date = new Date(time)
        date.setDate(date.getDate() + days)
        return new Date(date).getTime()
    }
    return ''
}


// 转成当前对应的时分秒
export function MinuteAndSeconds(time: Date, timeZone: number): number | string {
    if (time) {
        let date: string = formatDate(new Date(time), 'yyyy-MM-dd hh:mm:ss')
        if (timeZone) {
            return getLocalCompanyTimeStamp(timeZone, date)
        }
        return new Date(date).getTime()
    }
    return ''
}

// 时间戳转时间
export function LongToDateTime(time: Date | number, timeZone: number): number | string {
    if (time) {
        if (timeZone) {
            time = getLocalCompanyTime(timeZone, time)
        }
        return formatDate(new Date(time), 'dd/MM/yyyy hh:mm:ss')
    }
    return ''
}

// 时间戳转日期
export function LongToDate(time: Date | number, timeZone: number): number | string {
    if (time) {
        if (timeZone) {
            time = getLocalCompanyTime(timeZone, time)
        }
        return formatDate(new Date(time), 'dd/MM/yyyy')
    }
    return ''
}

export function convertTimezone(time, timeZone = 8, bool = false) {
    const gmt = new Date().getTimezoneOffset() / -60
    // 东八区直接返回
    if (gmt === timeZone) {
        return time
    }
    return getEast8Timestamp(time)
}

export function restoreTimezone(time, bool = true) {
    const gmt = new Date().getTimezoneOffset() / -60
    // 东八区直接返回
    if (gmt === 8) {
        return time
    }
    return getEast8Timestamp(time, bool)
}

export function getEast8Timestamp(dateTimeString, restore = false) {
    if (!dateTimeString) {
        return dateTimeString
    }
    // 创建 Date 对象并解析时间字符串
    const localDate = new Date(new Date(dateTimeString).toISOString())

    // 获取本地时区与 UTC 时区之间的偏移量（以分钟为单位）
    const offset = localDate.getTimezoneOffset()

    // 计算东八区的偏移量（东八区比 UTC 时区晚 8 小时）
    const east8Offset = -8 * 60 // 负号表示东八区比 UTC 时区晚

    // 计算东八区的时间戳
    let east8Timestamp
    if (restore) {
        east8Timestamp = localDate.getTime() + (offset - east8Offset) * 60 * 1000
    } else {
        east8Timestamp = localDate.getTime() - (offset - east8Offset) * 60 * 1000
    }
    return east8Timestamp
}

export function getTimezoneLabel() {
    const offset = -new Date().getTimezoneOffset() / 60
    const sign = offset >= 0 ? '+' : '-'
    return `GMT${sign}${Math.abs(offset)}`
}


export function getSecondsZeroTimestamp(time) {
    if (!time) return time
    return new Date(time).setSeconds(0, 0)
}
